import {SDK_PATH} from "@app/pages/widget/Integration"
import { Button, useModal } from "@shortsworks/ui";
import { Link, useLocation } from "react-router-dom";
import {
  getCafe24ThemeList,
  useGetCafe24ScriptList,
  useSetCafe24Script,
  useUpdateCafe24Script,
} from "@shortsworks/user-api";
import { useState } from "react";
import { CommonErrorModal } from "@app/components/modals/CommonErrorModal";
import { CommonModal } from "@app/components/modals/CommonModal";
import { QRCodeSVG } from "qrcode.react";
import { PlatformType } from "@app/types/platform";

export const RegistrationComplete = () => {
  const { showModal } = useModal();
  const location = useLocation();
  const platformType = location.state?.platformType ?? PlatformType.SHORTSWORKS;
  const platformId = location.state?.platformId ?? "";

  const getCafe24Script = useGetCafe24ScriptList<any>(platformId);
  const postCafe24Script = useSetCafe24Script();
  const updateCafe24Script = useUpdateCafe24Script();

  const [isCafe24ScriptInstalled, setIsCafe24ScriptInstalled] = useState(false);

  // 타입 확실하지 않는 부분 체크 필요
  const getExistScript = async () => {
    const [pc, mobile] = await Promise.all<any>([
      getCafe24ThemeList(platformId, { deviceType: "pc" }),
      getCafe24ThemeList(platformId, { deviceType: "mobile" }),
    ]);

    const themes = [...pc.themes, ...mobile.themes];
    const numbers = themes.map((theme) => theme["skin_no"]);

    return {
      script: getCafe24Script.data.scripttags.find((script: {src: string}) => script.src === SDK_PATH,
      ),
      numbers,
    };
  };

  const handleInstallCafe24Script = async () => {
    if (!getCafe24Script.isSuccess) {
      return showModal(CommonErrorModal, {
        title: "스크립트 목록을 불러오기 실패했습니다.",
      });
    }

    try {
      const { script, numbers } = await getExistScript();

      let result;
      if (typeof script === "undefined") {
        result = await postCafe24Script.mutateAsync({
          data: {
            mall_id: platformId,
            src: SDK_PATH,
            skin_no: numbers,
            integrity: "",
          },
        });
      } else {
        result = await updateCafe24Script.mutateAsync({
          data: {
            mall_id: platformId,
            src: SDK_PATH,
            //@ts-ignore
            script_no: numbers,
            integrity: "",
          },
        });
      }
      // @ts-ignore
      if (!result?.scripttag) {
        return showModal(CommonErrorModal, {
          title: "스크립트 설치를 실패했습니다.",
        });
      }
      setIsCafe24ScriptInstalled(true);
      return showModal(CommonModal, { title: "스크립트가 설치되었습니다." });
    } catch (error) {
      showModal(CommonErrorModal, { title: "스크립트 설치를 실패했습니다." });
    }
  };

  return (
    <div className="flex flex-col gap-4">
      <div className="font-bold">가입 완료</div>
      <div>
        축하드립니다! 회원가입이 완료되었습니다. 쇼츠웍스 앱을 설치하고 다양한
        숏폼 영상을 제작해 보세요.
      </div>
      {platformType === PlatformType.CAFE24 && <></>}
      <Button
        disabled={isCafe24ScriptInstalled}
        onClick={handleInstallCafe24Script}
      >
        카페24 스크립트 설치
      </Button>
      <Link to="/">
        <Button className="w-full" variant="outline">
          관리 페이지로 이동
        </Button>
      </Link>
      <div className="flex flex-row gap-8">
        <div>
          <QRCodeSVG value="https://play.google.com/store/apps/details?id=com.shortsworks.app.a" />
          <div>안드로이드</div>
        </div>
        <div>
          <QRCodeSVG value="https://apps.apple.com/kr/app/%EC%87%BC%EC%B8%A0%EC%9B%8D%EC%8A%A4/id6451084966" />
          <div>아이폰</div>
        </div>
      </div>
    </div>
  );
};
